<template>
    <div class="panel employee-list mb-3">
        <div class="row">

            <div class="d-md-none d col-xs-12 col-sm-12 col-md-2 col-xl-4 mb-2 text-right">
                <b-button variant="success"
                          type="button"
                          class="mx-1 text-nowrap"
                          :disabled="!filter.selectedRest.guid || !filter.selectedRole.guid"
                          @click="addNew()">
                    <span class="mdi mdi-pencil"></span> {{ $t("#TR-add-new") }}
                </b-button>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-4 col-xl-4 mb-2">
                <label>{{ $t("#TR-restaurants") }}</label>
                <b-dropdown
                    block
                    split-variant="outline-secondary"
                    variant="secondary"
                    :text="filter.selectedRest.name"
                    menu-class="w-100"
                    class="w-100">
                    <b-dropdown-item
                        v-for="rest in restList"
                        :key="rest['sifr']"
                        href="#"
                        @click="selectRest(rest)">
                        {{ rest.name }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-xl-4 mb-2">
                <label>{{ $t("#TR-roles") }}</label>
                <b-dropdown
                    block
                    :disabled="!filter.selectedRest.guid"
                    split-variant="outline-secondary"
                    variant="secondary"
                    :text="filter.selectedRole.name"
                    menu-class="w-100"
                    class="w-100">
                    <b-dropdown-item
                        v-for="role in roleList"
                        :key="role['sifr']"
                        href="#"
                        @click="selectRole(role)">
                        {{ role.name }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="d-none d-md-block d col-xs-12 col-sm-12 col-md-4 col-xl-4 mb-2 text-right">
                <b-button variant="success"
                          type="button"
                          class="mx-1 text-nowrap"
                          :disabled="!filter.selectedRest.guid || !filter.selectedRole.guid"
                          @click="addNew()">
                    <span class="mdi mdi-pencil"></span> {{ $t("#TR-add-new") }}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { ApiEditor } from '@/services/api';

export default {
    name: 'EmployeeFilter',
    components: {},
    mixins: [],
    props: [],
    data() {
        return {
            restList: [],
            roleList: [],
            filter: {
                selectedRest: {
                    name: this.$t('#TR-select'),
                    guid: null,
                    sifr: null
                },
                selectedRole: {
                    name: this.$t('#TR-select'),
                    guid: null,
                    sifr: null
                }
            }
        };
    },
    computed: {},

    async created() {
        await this.getRests();

    },

    methods: {

        async getRests() {
            const result = await ApiEditor.getRest();
            this.restList = result.data;
        },

        async getRoles(sifr) {
            const result = await ApiEditor.getRestRole(sifr);
            this.roleList = result.data;
        },

        selectRest(rest) {
            if (this.filter.selectedRest === rest) {
                return;
            }

            this.filter.selectedRest = rest;
            this.filter.selectedRole = {
                name: this.$t('#TR-select'),
                guid: null,
                sifr: null
            };
            this.getRoles(this.filter.selectedRest.sifr);
            this.$emit('changeRest');
        },

        selectRole(role) {
            if (this.filter.selectedRole === role) {
                return;
            }

            this.filter.selectedRole = role;
            this.$emit('getEmployeesList', this.filter);
        },

        addNew() {
            this.$emit('addNew');
        }
    }
};
</script>

<style lang="stylus">
.dropdown {
    .dropdown-toggle-split {
        width: 50px !important
        flex: none !important
    }
}
</style>
